import { GestureResponderEvent, Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import { Icon, IconName } from '@/components/Icon';
import { useResponsiveHeight } from '@/components/Util/reactResponsiveDimensions';
import theme from '@/config/theme';
import OfflineImage from '@/components/SharedComponents/OfflineImage/OfflineImage';
import { styles } from './ExerciseCard.styles';
import React from 'react';

interface ExerciseCardProps {
  onPress: (e: GestureResponderEvent) => void;
  iconName?: IconName;
  imageSrc?: number | { uri: string };
  label: string;
  isActive: boolean;
}

export function ExerciseCard({
  onPress,
  iconName,
  imageSrc,
  label,
  isActive,
}: ExerciseCardProps) {
  const responsiveFontHeight = useResponsiveHeight(2);
  const getResponsiveFontSize = (factor: number) => {
    return responsiveFontHeight * factor;
  };

  const responsizeIconSize = getResponsiveFontSize(4);
  const responsizeIconSizeBig = getResponsiveFontSize(7.5);
  const responsizeFontSize = getResponsiveFontSize(1.5);

  function handlePressCard(e: GestureResponderEvent) {
    onPress(e);
  }

  return (
    <Pressable
      testID={label}
      onPress={handlePressCard}
      style={styles.pressable}
    >
      <View style={styles.card}>
        <View style={[styles.iconContainer, { padding: responsizeIconSize }]}>
          {!!imageSrc && (
            <OfflineImage source={imageSrc} style={styles.image} />
          )}

          {!!iconName && (
            <Icon
              name={iconName}
              size={responsizeIconSizeBig}
              color={theme.colors.darkGrey}
            />
          )}
        </View>
        <View style={styles.labelWrapper}>
          <Text
            numberOfLines={2}
            style={[styles.labelText, { fontSize: responsizeFontSize }]}
          >
            {label}
          </Text>
        </View>

        <View
          style={[
            styles.badge,
            { top: responsizeFontSize / 3, right: responsizeFontSize / 3 },
          ]}
        >
          <Icon
            name={isActive ? 'checkboxCircleMarked' : 'checkboxCircleUnmarked'}
            size={responsizeIconSize}
            color={isActive ? theme.colors.primary : theme.colors.darkGrey}
          />
        </View>
      </View>
    </Pressable>
  );
}

export default React.memo(ExerciseCard);
